import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  expiresIn: null,
  tokenType: null,
  authState: {
    email: null,
    user: null,
    company: null,
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.token = action.payload.token;
      state.expiresIn = action.payload.expiresIn;
      state.tokenType = action.payload.tokenType;
      state.authState = {
        email: action.payload.authState.email,
        user: action.payload.authState.user,
        company: action.payload.authState.company,
      };
    },
    resetUserInfo: (state) => {
      state.token = null;
      state.expiresIn = null;
      state.tokenType = null;
      state.authState = {
        email: null,
        user: null,
        company: null,
      };
    },
  },
});

export const { setUserInfo, resetUserInfo } = authSlice.actions;

export default authSlice.reducer;
